import React from 'react';
import { useClinicModule } from '../../hooks/queries/usePharmacyFeatures';

interface ClinicModuleGateProps {
  children: React.ReactNode;
  /** Shown while the pharmacy flags load — a Skeleton the size of the gated control. */
  skeleton?: React.ReactNode;
  /** Shown when the module is off. Default: nothing. */
  fallback?: React.ReactNode;
}

/**
 * PRX-44: renders clinic / IV UI only for a pharmacy whose Clinic / IV module
 * is on. While the flags load it renders `skeleton` (never the module — no
 * flash in and out); when the module is off it renders `fallback`.
 */
export const ClinicModuleGate: React.FC<ClinicModuleGateProps> = ({ children, skeleton = null, fallback = null }) => {
  const { enabled, loading } = useClinicModule();
  if (loading) return <>{skeleton}</>;
  if (!enabled) return <>{fallback}</>;
  return <>{children}</>;
};
